(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifStateLabel', swifStateLabel)
    /**
     * @ngdoc directive
     * @name swif.ui:swifStateLabel
     * @module swif.ui
     * @restrict E
     * @description Display a label based on workflow state
     **/
    .directive('swifConsumableRequestStateLabel', swifConsumableRequestStateLabel);
        /**
     * @ngdoc directive
     * @name swif.ui:swifConsumableRequestStateLabel
     * @module swif.ui
     * @restrict E
     * @description Display a state label element for a consumable request within a task model (consumable_request_state)
     **/

    function swifStateLabel(swif) {
        'ngInject';
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {},
            link: function (scope, element, attr, ngModel) {
                var setState = function (state) {
                    scope.state = swif.state.getStateInfo(state, ngModel.$viewValue);
                };
                ngModel.$render = function () {
                    scope.proxy = ngModel.$viewValue;
                };
                scope.$watch('proxy.state', function (newV) {
                    if (newV) {
                        setState(newV);
                    }
                });
            },
            template: '<span class="label" ng-class="state.stateClass">{{state.title | translate}}</span>'
        };
    }

    function swifConsumableRequestStateLabel(swif) {
        'ngInject';
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {},
            link: function (scope, element, attr, ngModel) {
                var setState = function (state) {
                    scope.state = swif.settings.getContentType('openstc_ask_prod').states[state];
                };
                ngModel.$render = function () {
                    scope.proxy = ngModel.$viewValue;
                };
                scope.$watch('proxy.consumable_request_state', function (newV) {
                    if (newV) {
                        setState(newV);
                    }
                });
            },
            template: '<span class="label label-{{ state.labelclass }}">{{state.title}}</span>'
        };
    }

})();
